import { render, staticRenderFns } from "./ListarMotivoCancelamento.vue?vue&type=template&id=6f327752"
import script from "./ListarMotivoCancelamento.vue?vue&type=script&lang=js"
export * from "./ListarMotivoCancelamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports